import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';

import App from './App';
import store, { history } from './state/store';
import AuthApi from './api/auth';
import 'babel-polyfill';
// Begin the refreshing of tokens...
AuthApi.refreshToken();
const target = document.getElementById('root');

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    target
);
